 // product processing 
 $('[qft-product-remove]').on('click', (el) => {
    let prdctKey = parseInt($(el.currentTarget).attr('qft-product-remove'));
    jQuery.post('/cart/change.js', { quantity: 0, id: prdctKey }).then(()=>{updateCart();});
});
// quantity Button 
$('.qun_btn').on('click', (el) => {
    let input_el = el.currentTarget.parentElement.children[1];
    let quantity = input_el.getAttribute('qft-qun-itm');
    let prdct_key = input_el.getAttribute('qft-itm-key');
    if (el.currentTarget.classList.contains('qun_plus'))
        quantity++;
    else if (el.currentTarget.classList.contains('qun_minus')) {
        quantity--;
    }
    updateQuantity(quantity, prdct_key, input_el);
});